import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import type { UtmParams } from '@app/libs/analytics/events';
import { parseUtmParams } from '@supplierRegistration/utils/utmParams';

export default function useUtmParamsFromLocation(): UtmParams {
  const location = useLocation();
  const search = location?.search ?? '';
  return useMemo(() => parseUtmParams(qs.parse(search)), [search]);
}
